export const priorities = {
	'Composed From Lecture': 1,
	'Found on Internet': 10,
	'From Nadine\'s Pdf': 30,
	'Frequent From Nadine\'s Pdf': 40,
	'From Dr Ahmed\'s PDF': 50,
};

export const priorityColors = {
	[priorities['Composed From Lecture']]: 'rgb(0, 174, 243)',
	[priorities['From Dr Ahmed\'s PDF']]: 'rgb(192, 0, 192)',
	[priorities['From Nadine\'s Pdf']]: 'rgb(0, 255, 13)',
};